<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="analysisTemplate.pkid > 0 ? '编辑':'新建'"
        width="800px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="analysisTemplate"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <el-form-item label="名称">
          <el-input v-model="analysisTemplate.itemName" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="analysisTemplate.itemContent" type="textarea" autosize placeholder="请输入"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name:"",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        analysisTemplate: {
          pkid:"",
          itemContent: "",
          itemName: "",
        },
        ruleValidate: {
          itemName: {required: true, message: "名称不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        console.log(row);
        this.analysisTemplate.pkid = row.pkid;
        this.dialogVisible = true;
        if(this.analysisTemplate.pkid>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `analysisTemplates/${this.analysisTemplate.pkid}`)
          .then(resp => {
            this.analysisTemplate = resp;
          });
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if(this.analysisTemplate.pkid>0) {
              this.$http
                .put("basic", "analysisTemplates", this.analysisTemplate)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }else {
              this.$http
                .post("basic", "analysisTemplates", this.analysisTemplate)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
